module.exports = __webpack_public_path__ + "static/media/refresh.fb3c6b90.svg";